import type { QuickJournalThemeName, QuickJournalThemeSelectionName } from "../QuickJournalTheme";

function Group(theme: string | null): "day" | "night" | undefined {
    if (theme === "dune" || theme === "chromaflare") return "day";
    if (theme === "night" || theme === "cyberpunk") return "night";
    return undefined;
}

export function RememberQuickJournalAutoTheme(theme: QuickJournalThemeSelectionName): void {
    const group = Group(theme);
    if (!group || typeof window === "undefined") return;
    window.localStorage.setItem(`quickJournal_auto_${group}Theme`, theme);
}

export function LoadQuickJournalAutoTheme(isDark: boolean): QuickJournalThemeName {
    const group = isDark ? "night" : "day";
    const fallback = isDark ? "night" : "dune";
    if (typeof window === "undefined") return fallback;
    try {
        const preferred = window.localStorage.getItem(`quickJournal_auto_${group}Theme`);
        if (Group(preferred) === group) return preferred as QuickJournalThemeName;
        // Seed the new preference from the user's existing manual selection.
        const previous = window.localStorage.getItem("quickJournal_themeName");
        if (Group(previous) === group) return previous as QuickJournalThemeName;
    } catch { /* Auto remains usable when browser storage is blocked. */ }
    return fallback;
}
